import React from 'react';
import styled from 'styled-components';
import { colors } from '~/constants/colors';
import { fontSize } from '~/constants/text';

const StyledLabel = styled.div.withConfig({ componentId: 'sc-ysk3pi-0' })`
  font-size: ${fontSize.default};
  color: ${colors.grey600};
`;
const PatientDifferentAddressLabel = () => {
  return <StyledLabel>Patient has a different address</StyledLabel>;
};

export default PatientDifferentAddressLabel;
